// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDZWXCekfwH_ewCcMJbkxX-HtNMIicnpWo",
  authDomain: "mais-vendas-api.firebaseapp.com",
  projectId: "mais-vendas-api",
  storageBucket: "mais-vendas-api.firebasestorage.app",
  messagingSenderId: "528945932204",
  appId: "1:528945932204:web:424df28250484295b57c09",
  measurementId: "G-9LRM6RTJKT"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const firebaseDB = getFirestore(app);